export default {
  methods: {
    printUrl: function(code) {
      return process.env.VUE_APP_DOWNLOAD_URL + 'lead/pdf/' + code;
    },
  }
}
